import { useEffect , useRef , useState } from "react";
import AnalyticService from '../../../services/analyticService';
import AnalyticsGraphHook from "../AnalyticsGraph/AnalyticsGraphHook";
import { useAnalyticsDispatchContext , useAnalyticsStateContext } from "../../../context/AnalyticsContext";

function useAnalyticsTopBarHookData(name, channel_type_id, firstPeriod, channel_id, condition_id, redirection_id) {
   
    const data = { channel_type_id, date_start : firstPeriod.date_start, date_end : firstPeriod.date_end, channel_id, condition_id, redirection_id }
    const dispatch = useAnalyticsDispatchContext();
    const { clickedLabel , clickedTime , clickedDate , metrics, metrics_id } = useAnalyticsStateContext();
    const previousMetricValueRef = useRef();

    const { getMetricValue } = AnalyticsGraphHook(metrics, metrics_id);
    const [isReset, setIsReset] = useState(false);

    const { deleteAll, ...analyticService } = AnalyticService;


    useEffect(() => {
        const currentMetricValue = getMetricValue();
        if (currentMetricValue !== undefined && previousMetricValueRef.current !== currentMetricValue) {
            dispatch({ type: 'RESET_CLICKED_STATES' });
            setIsReset(true);
        }
        previousMetricValueRef.current = currentMetricValue;
    }, [getMetricValue]);

    useEffect(() => {
        const fetchData = async () => {
            dispatch({ type: 'SET_LOADING', payload: true });
            try {
                var [metrics, error] = await analyticService.getMetrics(name, data);
                if (error) {
                    dispatch({ type: 'SET_LOADING', payload: false });
                    return;
                }

                //var condition_id = metrics.conditions[0] ? metrics.conditions[0].id : null; // avant on affichait la premiere condition, plus maintenant
                var condition_id = null; // la valeur pas defaut pour afficher les informations de "all metrics" 
                if (condition_id) {
                    dispatch({ type: 'setResultInformation', payload: { metrics, metrics_id: condition_id, condition_id } });
                } else {
                    //var redirection_id = metrics.redirections[0] ? metrics.redirections[0].id : null;// avant on affichait la premiere redirection, plus maintenant
                    var redirection_id = null; // la valeur pas defaut pour afficher les informations de "all metrics" 
                    if (redirection_id) {
                        dispatch({ type: 'setResultInformation', payload: { metrics, metrics_id: redirection_id, redirection_id } });
                    } else {
                        dispatch({ type: 'setResultInformation', payload: { metrics, metrics_id: null } });
                    }
                }
            } finally {
                dispatch({ type: 'SET_LOADING', payload: false });
            }
        }

        fetchData();
    }, []);

    useEffect(() => {
        if(name == undefined) {
            return;
        }

        const fetchData = async () => {
            dispatch({ type: 'SET_LOADING', payload: true });
            try {
                const requests = Object.values(analyticService).map(request => {
                    if (clickedLabel && !clickedTime) {
                        return request(name, { ...data, detail_date: clickedLabel });
                    } else if (clickedTime) {
                        return request(name, { ...data, detail_date: clickedDate, detail_time: clickedTime });
                    } else {
                        return request(name, data);
                    }
                });
                const responses = await Promise.all(requests);
                const [channelsResponse, analyticsResponse, metricsResponse, peakActivityResponse, redirectionResponse] = responses;
                
                var payload = { channels: channelsResponse[0], analytics: analyticsResponse[0]?.data, metrics: metricsResponse[0], peakActivity: peakActivityResponse[0], redirectionActivity: redirectionResponse[0]};

                if (redirection_id != null && metricsResponse[0]?.redirections.filter(redirection => redirection.id == redirection_id).length == 0) {
                    payload = { ...payload, metrics_id: null, redirection_id: null };
                }

                if (condition_id != null && metricsResponse[0].conditions.filter(condition => condition.id == condition_id).length == 0) {
                    payload = { ...payload, metrics_id: null, condition_id: null };
                }

                dispatch({ type: 'setResultInformation', payload });
            } finally {
                dispatch({ type: 'SET_LOADING', payload: false });
            }
        }

        fetchData()

    }, [name, channel_type_id, firstPeriod.date_start, firstPeriod.date_end, condition_id, redirection_id, channel_id, clickedLabel, clickedTime]);
}

export default useAnalyticsTopBarHookData;